import React, { useEffect, useState,useCallback } from "react";
import api from "../services/api";
// import "../assets/styles/sidenav.scss";
import { Link, useNavigate } from "react-router-dom";
import { NavLink } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  SetClickCamp,
  SetCampCount,
  Headersearch,
  SetOpsSales,
  SetDate,
  SetLIstatus,
  SetorderStatus,
  SetShowsideNav,
  SetComponentId
} from "../redux/counterSlice";
import { SlBadge, SlIcon } from "@shoelace-style/shoelace/dist/react";
import { roles } from "../utils/constants";


function Sidenav({ routes }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const showSidenav =  useSelector((state) => state.Head.showSideNav)
  const [showCampaignsSubMenu, setShowCampaignsSubMenu] = useState(false);
  const [showLineitemsSubMenu, setShowLineitemsSubMenu] = useState(false)
  const [showOrdersSubMenu, setShowOrdersSubMenu] = useState(false)
  const SALES_OPS_ADV = useSelector((state) => state.Head.campcount);
  const SALES_OPS_ADV_ORDER = useSelector((state) => state.Head.sales_ops_order);
  const [data, setCampdata] = useState([]);
  const [lICountData, setLICountData] = useState([])
  const [orderCountData, setOderCountData] = useState([])
  const [statuscount, setStatusCount] = useState({
    queued: 0,
    approved: 0,
    blocked: 0,
  });
  const [status, setStatus] = useState(1);
  const [birdviewAiFilterCount, SetBirdViewFiltersCount] = useState(0)
  const [birdviewAiRejectCount, SetBirdViewRejectCount] = useState(0)
  const Networkdate = useSelector((state) => state.Head.network_ads_date);
  const NetworkAdType = useSelector((state) => state.Head.network_ad_type);
  const NetworkAdSearch = useSelector((state) => state.Head.network_ad_search);
  const birdviewFilters = useSelector((state) => state.Head.birdViewAiFiters);
  const birdviewRejectFilters = useSelector((state) => state.Head.birdviewRejectFilters);
  const handleCampaignsClick = () => {
    setShowCampaignsSubMenu(!showCampaignsSubMenu);
  };
  const handleLineitemsMenuClick = () => {
    setShowLineitemsSubMenu(!showLineitemsSubMenu);
  };
  const activeComponentId = useSelector((state) => state.Head.component_id);

  const getcampaigncount = async (SALES_OPS_ADV) => {
    try {
      if (localStorage.getItem("role") !== roles.b2b) {
        let res = await api({
          url: "/user/campaign_creation/count_camp",
          method: "POST",
          responseType: "json",
          data: {
            id: SALES_OPS_ADV,
          },
        });
        // setCampdata(res.data)
        if (res.code === 200) setCampdata(res.data);
        else setCampdata([]);
      }
    } catch (error) {
      console.error(error);
      if (error.response.status === 401) navigate("/");
    }
  };
  const getLineitemCount = async (SALES_OPS_ADV) => {
    try {
      if (localStorage.getItem("role") !== roles.b2b) {
        let res = await api({
          url: "/lineitems/count_lineitem",
          method: "POST",
          responseType: "json",
          data: {
            id: SALES_OPS_ADV,
          },
        });
        if (res.code === 200) setLICountData(res.data);
        else setLICountData([]);
      }
    } catch (error) {
      console.error(error);
      if (error.response.status === 401) navigate("/");
    }
  };
  const getOrderCount = async (SALES_OPS_ADV) => {
    try {
      if (localStorage.getItem("role") !== roles.b2b) {
        let res = await api({
          url: "/order/count-order",
          method: "POST",
          responseType: "json",
          data: {
            id: SALES_OPS_ADV_ORDER,
          },
        });
        if (res.code === 200) setOderCountData(res.data);
        else setOderCountData([]);
      }
    } catch (error) {
      console.error(error);
      if (error.response.status === 401) navigate("/");
    }
  };
  const getBirdVIewAiCount = useCallback(async(birdviewFilters)=>{
    try {
      let res = await api({
        url: "/birdview/count",
        method: "POST",
        responseType: "json",
        data: birdviewFilters
      });
      if (res.code === 200) SetBirdViewFiltersCount(res.data);
      else SetBirdViewFiltersCount(0);
    } catch (error) {
      console.error(error);
      if (error.response.status === 401) navigate("/");
    }
  },[])
  const getBirdVIewAiRejectCount = useCallback(async(birdviewFilters)=>{
    try {
      let res = await api({
        url: "/birdviewreject/count",
        method: "POST",
        responseType: "json",
        data: birdviewFilters
      });
      if (res.code === 200) SetBirdViewRejectCount(res.data);
      else SetBirdViewFiltersCount(0);
    } catch (error) {
      console.error(error);
      if (error.response.status === 401) navigate("/");
    }
  },[])
  const getNetworkadsCount = async () => {
    try {
      let res = await api({
        url: "/networkads/statuscount",
        method: "POST",
        responseType: "json",
        data: {
          date: Networkdate,
          type: NetworkAdType,
          search: NetworkAdSearch,
        },
      });
      if (res.code === 200) {
        const statusMap = {
          0: "queued",
          1: "approved",
          2: "blocked",
        };
        const mappedData = Object.values(statusMap).map((status) => {
          let match_id =
            status === "queued" ? 0 : status === "approved" ? 1 : 2;
          const dataItem = res.data.find((item) => item._id === match_id);

          const count = dataItem ? dataItem.count : 0;

          return {
            status: status,
            count: count,
          };
        });

        const result = mappedData.reduce((acc, { status, count }) => {
          acc[status.toLowerCase()] = count;
          return acc;
        }, {});
        setStatusCount(result);
      } else setStatusCount({ queued: 0, approved: 0, blocked: 0 });
    } catch (error) {
      console.error(error);
      if (error.response.status === 401) navigate("/");
    }
  };

  const handleCountClick = (status) => {
    dispatch(SetClickCamp(status));
  };
  const handleLICountClick = (status) => {
    dispatch(SetLIstatus(status));
  };
  const handleOrderCountClick = (status) => {
    dispatch(SetorderStatus(status));
  };

  const submenuItemsops = [
    { title: "Created", to: "/home/campaign/created", status: 1 },
    { title: "Running", to: "/home/campaign/running", status: 2 },
    { title: "Paused", to: "/home/campaign/paused", status: 3 },
    { title: "Completed", to: "/home/campaign/completed", status: 4 },
    { title: "Scheduled", to: "/home/campaign/scheduled", status: 5 },
  ];
  const submenuItemsnonops = [
    { title: "Running", to: "/home/campaign/running", status: 2 },
    { title: "Paused", to: "/home/campaign/paused", status: 3 },
    { title: "Completed", to: "/home/campaign/completed", status: 4 },
  ];
  const lineitemsStatusRoutes = [
    { title: "Created", to: "/home/lineitems/created", status: 1 },
    { title: "Approved", to: "/home/lineitems/approved", status: 6 },
    { title: "Running", to: "/home/lineitems/running", status: 2 },
    { title: "Paused", to: "/home/lineitems/paused", status: 3 },
    { title: "Completed", to: "/home/lineitems/completed", status: 4 },
    { title: "Scheduled", to: "/home/lineitems/scheduled", status: 5 },
    { title: "Internal", to: "/home/lineitems/internal", status:-2}
  ];
  const orderStatusRoutes = [
    { title: "Running", to: "/home/order/running", status: 1 },
    { title: "Paused", to: "/home/order/paused", status: 2 },
    { title: "Completed", to: "/home/order/completed", status: 3 },
    { title: "Internal", to: "/home/order/internal",status: -2}
  ];

  useEffect(() => {
    if (
      ["created", "running", "paused", "completed", "scheduled"].includes(
        window.location.pathname.split("/").pop()
      )
    ) {
      setShowCampaignsSubMenu(true);
    }
    if (
      showCampaignsSubMenu &&
      localStorage.getItem("role") !== roles.network_ad_manager
    ) {
      const interval = setInterval(() => {
        if (SALES_OPS_ADV === -1 || SALES_OPS_ADV === "")
          getcampaigncount({ index: -1, value: -1 });
        else getcampaigncount(SALES_OPS_ADV);
      }, 3000);
      if (SALES_OPS_ADV === -1 || SALES_OPS_ADV === "")
        getcampaigncount({ index: -1, value: -1 });
      else getcampaigncount(SALES_OPS_ADV);

      return () => {
        clearInterval(interval);
      };
    }
  }, [SALES_OPS_ADV, showCampaignsSubMenu]);

  useEffect(() => {
    if (
      ["created", "running", "paused", "completed", "scheduled", "approved"].includes(
        window.location.pathname.split("/").pop()
      )
    ) {
      setShowLineitemsSubMenu(true);
    }
    if (
      showLineitemsSubMenu &&
      localStorage.getItem("role") !== roles.network_ad_manager
    ) {
      const interval = setInterval(() => {
        if (SALES_OPS_ADV === -1 || SALES_OPS_ADV === "")
          getLineitemCount({ index: -1, value: -1 });
        else getLineitemCount(SALES_OPS_ADV);
      }, 3000);
      if (SALES_OPS_ADV === -1 || SALES_OPS_ADV === "")
        getLineitemCount({ index: -1, value: -1 });
      else getLineitemCount(SALES_OPS_ADV);
      return () => {
        clearInterval(interval);
      };
    }
  }, [SALES_OPS_ADV, showLineitemsSubMenu]);

  useEffect(() =>{
    if (
      ["running", "paused", "completed"].includes(
        window.location.pathname.split("/").pop()
      )
    ) {
      setShowOrdersSubMenu(true);
    }
    if (
      showOrdersSubMenu &&
      localStorage.getItem("role") !== roles.network_ad_manager
    ) {
      const interval = setInterval(() => {
        if (SALES_OPS_ADV_ORDER === -1 || SALES_OPS_ADV_ORDER === "")
          getOrderCount({ index: -1, value: -1 });
        else getOrderCount(SALES_OPS_ADV_ORDER);
      }, 3000);
      if (SALES_OPS_ADV_ORDER === -1 || SALES_OPS_ADV_ORDER === "")
        getOrderCount({ index: -1, value: -1 });
      else getOrderCount(SALES_OPS_ADV_ORDER);
      return () => {
        clearInterval(interval);
      };
    }
  }, [SALES_OPS_ADV_ORDER, showOrdersSubMenu]);

  useEffect(() => {
    if (localStorage.getItem("role") === roles.network_ad_manager) {
      const campInterval = setInterval(() => {
        if (Networkdate === "") {
          getNetworkadsCount();
        } else {
          getNetworkadsCount();
        }
      }, 30000);
      if (Networkdate === "") {
        getNetworkadsCount();
      } else {
        getNetworkadsCount();
      }
      return () => {
        clearInterval(campInterval);
      };
    }
  }, [Networkdate, NetworkAdType, status]);


  useEffect(()=>{
    if(localStorage.getItem('role') === roles.b2b)
    getBirdVIewAiCount(birdviewFilters)
  },[birdviewFilters])

  useEffect(()=>{
    if(localStorage.getItem('role') === roles.b2b)
      getBirdVIewAiRejectCount(birdviewRejectFilters)
  },[birdviewRejectFilters])


  const handleClick = () => {
    dispatch(Headersearch(""));
    // dispatch(SetOpsSales(''))
    dispatch(SetDate(""));
    dispatch(SetClickCamp(-1));
    dispatch(SetLIstatus(-1))
    let width = window.innerWidth 
    if (width <= 767) dispatch(SetShowsideNav(!showSidenav)) 
  };

  return (
    <aside className={`sidebar ${showSidenav ? 'show-sidenav' : 'close-sidenav'}`}>
      <div className="absolute top-3 right-2 block sm:hidden" onClick={()=>{ dispatch(SetShowsideNav(!showSidenav)) }}>
            <SlIcon library="lucide" name="arrow-left" ></SlIcon>
          </div>
      <nav className="main-nav" style={{ listStyleType: "none" }}>
      
        <li className="menu-title d-flex justify-between" data-key="t-menu">
          <span>Menu</span>
          
        </li>
        {localStorage.getItem('role') === roles.salesperson && <>
        <li className="menu-title" data-key="t-menu">
          Growth Management
        </li>
        {
          routes.map((item) => (
            <li key={item.id} onClick={handleClick}>
              {(item.id === 33 || item.id === 34 || item.id === 35 || item.id === 36 || item.id === 37 || item.id === 38 || item.id === 39 || item.id === 42 || item.id === 43 || item.id === 45 || item.id === 48  || item.id === 67  )? <NavLink className={(activeComponentId === 34 && item.id === 34) ? 'active' : ''} to={item.path}>
                <span className="d-center">{item.title}</span>
              </NavLink> : null}
            </li>
          ))
        }
        </>}
        <li className="menu-title" data-key="t-menu">
          Delivery
        </li>
        {routes?.map((item) => (
          <li key={item.id} onClick={handleClick}>
            {item.id === 3 ? (
              <div>
                <NavLink className="devider" to={item.path}>
                  <span className="d-center">
                    {item.title}
                    {showCampaignsSubMenu ? (
                      <sl-icon
                        name="chevron-down"
                        library="lucide"
                        onClick={handleCampaignsClick}
                      ></sl-icon>
                    ) : (
                      <sl-icon
                        name="chevron-right"
                        library="lucide"
                        onClick={handleCampaignsClick}
                      ></sl-icon>
                    )}
                  </span>
                </NavLink>
              </div>
            ): item.id === 24 ? (
              <>
              <div>
                <NavLink className="" to={item.path} onClick={()=>handleOrderCountClick('all')}>
                  <span className="d-center">
                    {item.title}
                    {showOrdersSubMenu ? (
                      <sl-icon
                        name="chevron-down"
                        library="lucide"
                        onClick={() => setShowOrdersSubMenu(!showOrdersSubMenu)}
                      ></sl-icon>
                    ) : (
                      <sl-icon
                        name="chevron-right"
                        library="lucide"
                        onClick={() => setShowOrdersSubMenu(!showOrdersSubMenu)}
                      ></sl-icon>
                    )}
                  </span>
                </NavLink>
              </div>
              {item.id === 24 && showOrdersSubMenu && (
              <ul className="m-0 p-0 ">
                {( localStorage.getItem('role') === roles.ops || localStorage.getItem('role') === roles.salesperson
                  ? orderStatusRoutes
                  : orderStatusRoutes.filter(orderStatusItem => orderStatusItem.status !== -2))
                ?.map((submenuItem, index) => {
                  const countData = orderCountData?.find(
                    (item) => item.status === submenuItem?.status
                  );
                  const count = countData ? countData.count : 0;

                  return (
                    <li
                      className="submenu"
                      key={index}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleOrderCountClick(submenuItem.status);
                      }}
                    >
                      <NavLink to={submenuItem.to}>
                        <span className="grow">{submenuItem.title}</span>
                        <SlBadge className="badge-count" variant="neutral" pill>
                          {count}
                        </SlBadge>
                      </NavLink>
                    </li>
                  );
                })}
              </ul>
            )}</>
            ) : item.id !== 11 &&
              item.id !== 12 &&
              item.id !== 13 &&
              item.id !== 27 &&
              item.id !== 60 &&
              item.id !== 62 &&
                item.id !== 2 && item.id !== 21 && item.id !== 22 &&
                item.id !== 9 && item.id !== 8 && item.id !== 1 && item.id !== 26 &&
                item.id !== 14 && item.id !== 25  && item.id !== 33 && item.id !== 34 && item.id !== 35 && item.id !== 36 && item.id !== 37 && item.id !== 38  && item.id !== 39 && item.id !== 42 && item.id !== 43 && item.id !== 45 && item.id !== 48 && item.id !== 67 ? (
              <NavLink to={item.path}>
                <span className="d-center">{item.title}</span>
              </NavLink>
            ) : null}
            {
              item.id === 60 && <NavLink to={item.path} className="!flex justify-between !text-red-500 devider">
                <span className="d-center ">{item.title}</span>
                </NavLink>
            }
            {
              item.id === 62 && <NavLink to={item.path} className="!flex justify-betwee">
                <span className="d-center ">{item.title}</span><span className="font-semibold">{birdviewAiRejectCount}</span>
                </NavLink>
            }
            {item.id === 27 ? (
              <>
                <li className="menu-title" data-key="t-menu">
                  Inventory
                </li>
                <NavLink to={item.path}>
                  <span className="d-center ">{item.title}</span>
                </NavLink>
              </>
            ) : null}
            {
              item.id === 45 && localStorage.getItem('role') === roles.ops ? (
                <>
                <li className="menu-title" data-key="t-menu">
                  Sales
                </li>
                <NavLink to={item.path}>
                  <span className="d-center ">{item.title}</span>
                </NavLink>
                </>
              ) : null
            }
            {item.id === 25 && (
              <div>
                <NavLink to={item.path}>
                  <span className="d-center">
                    {item.title}
                    {showLineitemsSubMenu ? (
                      <sl-icon
                        name="chevron-down"
                        library="lucide"
                        onClick={handleLineitemsMenuClick}
                      ></sl-icon>
                    ) : (
                      <sl-icon
                        name="chevron-right"
                        library="lucide"
                        onClick={handleLineitemsMenuClick}
                      ></sl-icon>
                    )}
                  </span>
                </NavLink>
              </div>
            ) }
            {item.id === 25 && showLineitemsSubMenu && (
              <ul className="m-0 p-0 ">
                {(localStorage.getItem('role') === roles.ops ? lineitemsStatusRoutes : lineitemsStatusRoutes.filter(liStatusItem => [2,3,4].includes(liStatusItem.status)))
                ?.map((submenuItem, index) => {
                  const countData = lICountData?.find(
                    (item) => item.status === submenuItem?.status
                  );
                  const count = countData ? countData.count : 0;

                  return (
                    <li
                      className="submenu"
                      key={index}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleLICountClick(submenuItem.status);
                      }}
                    >
                      <NavLink to={submenuItem.to}>
                        <span className="grow">{submenuItem.title}</span>
                        <SlBadge className="badge-count" variant="neutral" pill>
                          {count}
                        </SlBadge>
                      </NavLink>
                    </li>
                  );
                })}
              </ul>
            )}
            {item.id === 11 || item.id === 12 || item.id === 13 ? (
              <div>
                <NavLink
                  to={item.path}
                  onClick={() => {
                    setStatus(item.id === 11 ? 0 : item.id === 12 ? 1 : 2);
                  }}
                >
                  <div className="flex">
                    <span className="grow">{item.title}</span>
                    <SlBadge
                      className="badge-count"
                      variant="neutral"
                      title="Count"
                      pill
                    >
                      {item.id === 11
                        ? statuscount?.queued
                        : item.id === 12
                        ? statuscount?.approved
                        : statuscount?.blocked}
                    </SlBadge>
                  </div>
                </NavLink>
              </div>
            ) : null}
            {item.id === 2 && (
              <>
                <li className="menu-title" data-key="t-menu">
                  Reports
                </li>
                <NavLink to={item.path}>
                  <span className="d-center ">{item.title}</span>
                </NavLink>
              </>
            )}
            {(item.id === 21 || item.id === 22) && (
              <NavLink to={item.path}>
                <span className="d-center ">{item.title}</span>
              </NavLink>
            )}

            {item.id === 9 && (
              <>
                <li className="menu-title" data-key="t-menu">
                  Admin
                </li>
                <NavLink to={item.path}>
                  <span className="d-center ">{item.title}</span>
                </NavLink>
              </>
            )}
            {(item.id === 1 || item.id === 8 || item.id === 26) && (
              <NavLink to={item.path}>
                <span className="d-center ">{item.title}</span>
              </NavLink>
            )}
            {item.id === 14 && (
              <>
                <li className="menu-title" data-key="t-menu">
                  Others
                </li>
                <NavLink to={item.path}>
                  <span className="d-center ">{item.title}</span>
                </NavLink>
              </>
            )}
            {item.id === 3 && showCampaignsSubMenu && (
              <ul className="m-0 p-0 ">
                {(localStorage.getItem("role") === roles.ops ||
                localStorage.getItem("role") === roles.financer
                  ? submenuItemsops
                  : submenuItemsnonops
                )?.map((submenuItem, index) => {
                  const countData = data?.find(
                    (item) => item.status === submenuItem?.status
                  );
                  const count = countData ? countData.count : 0;

                  return (
                    <li
                      className="submenu"
                      key={index}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleCountClick(submenuItem.status);
                      }}
                    >
                      <NavLink to={submenuItem.to}>
                        <span className="grow">{submenuItem.title}</span>
                        <SlBadge className="badge-count" variant="neutral" pill>
                          {count}
                        </SlBadge>
                      </NavLink>
                    </li>
                  );
                })}
              </ul>
            )}
          </li>
        ))}
      </nav>

      {/* <div class="card sidebar-alert border-0 text-center mx-4 mb-0 mt-5">
                <div class="card-body">
                    <img src="../images/giftbox.png" alt="" />
                    <div class="mt-4">
                        <h5 class="alertcard-title font-size-16">Unlimited Access</h5>
                        <p class="font-size-13">Upgrade your plan from a Free trial, to select 'Business Plan'.</p>
                        <a href="#!" class="btn btn-primary mt-2">Upgrade Now</a>
                    </div>
                </div>
            </div> */}
    </aside>
  );
}

export default Sidenav;
